module.exports = __webpack_public_path__ + "img/35b8cf9e4757a0507721a79a3d565f13.97c6ef61.png";